import NotificationController from "../../../stories/_setting/Notifications/NotificationController";

class WebPushService {
    static async initSubscribeWebPush() {
        try {
            if (!WebPushService.hasPermission())
                await WebPushService.requestPermission();

            let subscription = await WebPushService.getSubscription();
            if (!subscription) {
                subscription = await WebPushService.subscribe();
            }

            console.log("Abonnement", subscription);

            WebPushService.saveSubscription(subscription);

            return subscription;
        }
        catch (e) {
            console.error(e);
            return null;
        }
    }
    static async unsubscribeWebPush() {
        try {
            let subscription = await WebPushService.unsubscribe();
            console.log("Désabonnement aux notifications push web", subscription);
            return subscription;
        } catch (e) {
            console.error(e);
            return null;
        }
    }
    static async checkSubscription() {
        if (!WebPushService.hasPermission())
            return null;

        return await WebPushService.getSubscription();
    }


    static hasPermission() {
        return Notification.permission === "granted";
    }

    static async requestPermission() {
        return await Notification.requestPermission();
    }

    static async getSubscription() {
        return await navigator.serviceWorker.ready.then(async (registration) => {
            let subscription = await registration.pushManager.getSubscription();
            return subscription;
        });
    }

    static async subscribe() {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true, applicationServerKey: process.env.REACT_APP_VAPID_PUBLIC_KEY,
        });
        return subscription;
    }

    static async unsubscribe() {
        const subscription = await this.getSubscription();

        if (subscription) {
            await subscription.unsubscribe();
            await WebPushService.saveUnsubscription(subscription);
        }
    }

    static saveSubscription(subscription) {
        const controller = new NotificationController();
        controller.subscribe(subscription.toJSON());
    }
    static saveUnsubscription(subscription) {
        const controller = new NotificationController();
        controller.unsubscribe(subscription.toJSON());
    }
}

export default WebPushService;